import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { PessoaService } from '../../shared/services/pessoa.service';
import { DocumentosListaExibirModel } from '../../shared/models/documentos-lista-exibir.model';
import { DocumentosService } from '../../shared/services/documentos.service';
import { StorafeUtil } from '../../shared/util/storasge.util';
import { CODIGO_CENTRUS } from '../../../app.constants';
import { NgBlockUI, BlockUI } from 'ng-block-ui';
import { MessageUtil } from '../../shared/messages/messageUtil';
import { AuthInterceptor } from '../../interceptor/auth.interceptor';
@Component({
  selector: 'app-pcd-demosntrativo',
  templateUrl: './pcd-demosntrativo.component.html',
  styleUrls: ['./pcd-demosntrativo.component.css']
})
export class PcdDemosntrativoComponent implements OnInit {

  @BlockUI() blockUi: NgBlockUI;

  param: string;

  cdCentrus: number;


  documentosListaExibirModel: DocumentosListaExibirModel[] = [];

  selectedDocumentosListaExibir: DocumentosListaExibirModel;

  constructor(
    private documentosService: DocumentosService,
    private pessoaService: PessoaService,
    private toastrService: ToastrService,
    private authInterceptor: AuthInterceptor,
    private router: Router
  ) {
  }


  ngOnInit() {
    this._gerenciarCodigoIndentificao();
  }

  getDadosSesseionStorage(): Promise<string> {

    return new Promise((resolve, reject) => {
      const recuperandoObjeto = StorafeUtil.recuperarSessionStorage(CODIGO_CENTRUS);
      resolve(recuperandoObjeto);
    })


  }


  private async _gerenciarCodigoIndentificao(): Promise<void> {
    await this.getDadosSesseionStorage()
    .then(recuperandoObjeto => {

      if (recuperandoObjeto) {
          const novoObjeto = Number(JSON.parse(recuperandoObjeto));
          this.cdCentrus = novoObjeto
          this.param = '/administrativo/operacoesConsultaParticipante';
        } else {
          this.cdCentrus = this.authInterceptor.getJwtCdCentrus();
          this.param = '/cardMenus/cardMenuPlanos';
        }
      })
      this.getObterCPFArquivoPCD();
  }



  async getObterCPFArquivoPCD() {
    this.documentosListaExibirModel = [];

    try {

      const cPFArquivoPCD = await this.pessoaService.getObterCPFArquivoPCD(this.cdCentrus);
      this.documentosListaExibirModel.push(new DocumentosListaExibirModel('Demonstrativo 2024', `2024_${cPFArquivoPCD['cpf']}.pdf`, 'arqpcd'))
      this.documentosListaExibirModel.push(new DocumentosListaExibirModel('Demonstrativo 2023', `2023_${cPFArquivoPCD['cpf']}.pdf`, 'arqpcd'))
      this.documentosListaExibirModel.push(new DocumentosListaExibirModel('Demonstrativo 2022', `2022_${cPFArquivoPCD['cpf']}.pdf`, 'arqpcd'))
      this.documentosListaExibirModel.push(new DocumentosListaExibirModel('Demonstrativo 2021', `2021_${cPFArquivoPCD['cpf']}.pdf`, 'arqpcd'))
      this.documentosListaExibirModel.push(new DocumentosListaExibirModel('Demonstrativo 2020', `2020_${cPFArquivoPCD['cpf']}.pdf`, 'arqpcd'))
      this.documentosListaExibirModel.push(new DocumentosListaExibirModel('Demonstrativo 2019', `2019_${cPFArquivoPCD['cpf']}.pdf`, 'arqpcd'))
      this.documentosListaExibirModel.push(new DocumentosListaExibirModel('Demonstrativo 2018', `2018_${cPFArquivoPCD['cpf']}.pdf`, 'arqpcd'))
      this.documentosListaExibirModel.push(new DocumentosListaExibirModel('Demonstrativo 2017', `2017_${cPFArquivoPCD['cpf']}.pdf`, 'arqpcd'))
      this.documentosListaExibirModel.push(new DocumentosListaExibirModel('Demonstrativo 2016', `2016_${cPFArquivoPCD['cpf']}.pdf`, 'arqpcd'))

    } catch (error) {

      console.error(error);

      this.router.navigate([this.param], { skipLocationChange: true });
      this.toastrService.info(MessageUtil.REGISTRO_NAO_ENCONTRADO, '', { timeOut: 8000 })
    }

  }



  downloandDocument(documento: DocumentosListaExibirModel): void {
    try {
      this.documentosService.downloandDocument(documento.tipo, documento.caminho);
    } catch (error) {
      console.error(error);
    }

  }


}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/planos/pcd-demosntrativo/pcd-demosntrativo.component.ts